// src/components/ui/Field.js
import React, { useId } from "react";

// ラベル付きテキスト入力
export function TextField({ label, value, onChange, ...rest }) {
  const id = useId();
  return (
    <div className="field">
      {label && (
        <label className="field__label" htmlFor={id}>
          {label}
        </label>
      )}
      <input
        id={id}
        className="input"
        value={value}
        onChange={onChange}
        {...rest}
      />
    </div>
  );
}

// ラベル付きセレクト
export function SelectField({ label, value, onChange, children, ...rest }) {
  const id = useId();
  return (
    <div className="field">
      {label && (
        <label className="field__label" htmlFor={id}>
          {label}
        </label>
      )}
      <select
        id={id}
        className="select"
        value={value}
        onChange={onChange}
        {...rest}
      >
        {children}
      </select>
    </div>
  );
}

// チェックボックス
export function CheckboxField({ label, checked, onChange, ...rest }) {
  return (
    <div className="field">
      <label className="checkbox">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          {...rest}
        />
        {label}
      </label>
    </div>
  );
}
